





























































































































import {
  CanalLead,
  CanalLeadCommand,
  CanalLeadService,
  Filtro,
} from "@/services/canal-lead.service";
import DataTable from "@/shared/components/data-table.vue";
import Loading from "@/shared/components/loading.vue";
import { Paginacao } from "@/shared/interface";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { ServerPageOptions } from "@/shared/utils/datatable";
import { required } from "@/shared/validators";
import { Component, Mixins, Ref } from "vue-property-decorator";

import Confirm from "@/shared/components/confirm.vue";
import Tooltip from "@/shared/components/tooltip.vue";
import ManterCanalProspeccao from "../modals/ManterCanalProspeccao.vue";
import { DataTableHeader } from "vuetify";

@Component({
  components: { Loading, DataTable, ManterCanalProspeccao, Tooltip, Confirm },
})
export default class CadastrosCanaisLeads extends Mixins(GlobalMixin) {
  loading = false;
  panel = [0, 1];
  canalLead: CanalLeadCommand | null = null;
  nomeCanal = "";
  text = "";
  snackbar = false;
  promise: Promise<Paginacao<CanalLeadCommand>> | null = null;

  @Ref() readonly manterCanalLead!: ManterCanalProspeccao;
  @Ref() readonly confirm!: Confirm;

  filtro: Filtro = {
    term: "",
    offset: 0,
    limit: 100,
    order: "",
  };

  rules = {
    nomeCanal: [required()],
  };

  headers: DataTableHeader[] = [
    { value: "nome", text: "Canais" },
    { value: "actions", text: "", sortable: false, width: "110px" },
  ];

  mounted() {
    this.filtro.term = "";
  }

  fetchCanaisLeads(options?: ServerPageOptions) {
    if (options) {
      Object.assign(this.filtro, options);
    }
    this.promise = CanalLeadService.listarCanaisLead(this.filtro);
  }

  editar(canal: CanalLead) {
    this.manterCanalLead.abrirModal(canal.idCanalLead);
  }

  async excluir(canal: CanalLead) {
    const title = "Excluir canal de prospecção?";
    const text = "Deseja realmente excluir o canal de prospecção?";
    const res = await this.confirm.open(title, text);
    if (res) {
      try {
        this.startLoader();
        await CanalLeadService.excluirCanalLead(canal.idCanalLead);
        this.fetchCanaisLeads();
      } finally {
        this.stopLoader();
      }
    }
  }

  async cadastrarCanal() {
    this.canalLead = {} as CanalLeadCommand;
    const form = this.$refs.formCadastro as any;
    this.canalLead.nome = this.nomeCanal;

    if (form.validate()) {
      if (this.canalLead) {
        this.loading = true;
        try {
          await CanalLeadService.cadastrarCanalLead(this.canalLead);
        } finally {
          this.loading = false;
          form.reset();
          this.fetchCanaisLeads();
          this.text = "Canal Cadastrado!";
          this.snackbar = true;
        }
      }
    }
  }
}
